import api from "../api/CustomerApi";

export const CouponServices = {
  checkCoupon: async (coupon) => {
    const res = await api.post("/check-coupon", {
      coupon,
    });

    return res.data;
  },
};